import React,{useEffect,useState}from'react';
import QRCode from'qrcode';
import{roomInvitationUrl}from'../core/roomInvitation.js';
export function RoomInvitation({origin,roomCode}) {
  const[image,setImage]=useState(null),[failed,setFailed]=useState(false);
  let url='';try{url=roomInvitationUrl(origin,roomCode);}catch{}
  useEffect(()=>{let current=true;setImage(null);setFailed(false);if(!url){setFailed(true);return()=>{current=false;};}
    QRCode.toDataURL(url,{width:256,margin:4,errorCorrectionLevel:'M',color:{dark:'#000000',light:'#ffffff'}}).then(src=>{if(current)setImage({url,src});},()=>{if(current)setFailed(true);});return()=>{current=false;};
  },[url]);
  return <figure className="room-invitation" aria-label="Room invitation QR" style={{margin:'16px 0'}}>
    {image?.url===url?<img src={image.src} alt={'Scan to join QLine room '+roomCode} width="256" height="256" style={{display:'block',width:'min(256px,100%)',height:'auto',background:'white',borderRadius:12}}/>:<p role="status">{failed?'QR unavailable. Use the room code or Actor join link.':'Preparing room QR…'}</p>}
    <figcaption>Scan with your phone camera to join room <strong>{roomCode}</strong>.</figcaption>
  </figure>;
}
